import { configureStore } from "@reduxjs/toolkit";

import modalReducer from "../slice/modal-slice/modalSlice";
import authReducer from "../slice/auth/authSlice";
import { authAPI } from "../api/auth";
import { appfolioAPI } from "../api/appfolio";
import { propertyManagerApi } from "../api/propertyManager";
import { propertyMappingApi } from "../api/propertyMapping";
import { accountMappingApi } from "../api/accountMapping";
import { bankMappingApi } from "../api/bankMapping";
import { systemAdminAPI } from "../api/system-access";

import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { profileApi } from "../api/profile";
import { dashboardAPI } from "../api/dashboard";
import { rolesPermissionsAPI } from "../api/rolesPermissions";


const persistConfig = {
  key: "auth",
  storage,
  whitelist: ["user", "token", "isAuthenticated"],
};

const persistedAuthReducer = persistReducer(persistConfig, authReducer);


export const store = configureStore({
  reducer: {
    modal: modalReducer,
    auth: persistedAuthReducer,
    [authAPI.reducerPath]: authAPI.reducer,
    [appfolioAPI.reducerPath]: appfolioAPI.reducer,
    [propertyManagerApi.reducerPath]: propertyManagerApi.reducer,
    [propertyMappingApi.reducerPath]: propertyMappingApi.reducer,
    [accountMappingApi.reducerPath]: accountMappingApi.reducer,
    [bankMappingApi.reducerPath]: bankMappingApi.reducer,
    [systemAdminAPI.reducerPath]: systemAdminAPI.reducer,
    [profileApi.reducerPath]: profileApi.reducer,
    [dashboardAPI.reducerPath]: dashboardAPI.reducer,
    [rolesPermissionsAPI.reducerPath]: rolesPermissionsAPI.reducer,
    
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false, }).concat(authAPI.middleware).concat(appfolioAPI.middleware).concat(propertyManagerApi.middleware).concat(propertyMappingApi.middleware).concat(accountMappingApi.middleware).concat(bankMappingApi.middleware).concat(systemAdminAPI.middleware).concat(profileApi.middleware).concat(dashboardAPI.middleware).concat(rolesPermissionsAPI.middleware),
});

export const persistor = persistStore(store);
